var map = {
	"./chocolat.jpeg": 53,
	"./default.jpeg": 25,
	"./epinard.jpg": 54,
	"./hamburger.jpeg": 55,
	"./pizza.jpeg": 56,
	"./saumon.jpeg": 57,
	"./tartine.jpg": 58
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52;